"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const luxon_1 = require("luxon");
const getDateTimeFromDateTimeComponents_1 = require("../utils/getDateTimeFromDateTimeComponents");
const ScheduledDateAndTimeLabel = ({ dateTime }) => {
    let { timeZone } = dateTime;
    const scheduledAt = getDateTimeFromDateTimeComponents_1.default(dateTime, 'UTC+12');
    const now = luxon_1.DateTime.local();
    const lifecycleStatus = now < scheduledAt ? 'SCHEDULED' : 'SENT';
    const dateString = scheduledAt.toFormat(`MMMM d, yyyy 'at' t`);
    const timeZoneDisplay = () => {
        if (!timeZone) {
            return React.createElement(src_1.GlobeIcon, { fill: src_1.charcoal, height: "12", width: "12", viewBox: "0 0 24 24", style: { marginLeft: 8 } });
        }
        else if (timeZone !== 'UTC') {
            return (React.createElement(src_1.Badge, { color: src_1.charcoal, text: timeZone, style: {
                    marginLeft: 8,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                } }));
        }
    };
    return (React.createElement("div", { style: {
            display: 'flex',
            alignItems: 'baseline',
        } },
        React.createElement(src_1.Badge, { color: lifecycleStatus === 'SENT' ? src_1.green : src_1.yellow, text: lifecycleStatus, style: { marginRight: 8 } }),
        React.createElement(src_1.Text, { size: "small", text: dateString }),
        timeZoneDisplay()));
};
exports.default = ScheduledDateAndTimeLabel;
